module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "to-user-tasks text-dark"
  }, [_c('table', {
    staticClass: "d-table marg-1-bottom d-table__overview"
  }, _vm._l((_vm.tasksByMasterType), function(tasksType, prop) {
    return _c('tbody', [_c('tr', {
      staticClass: "tr-thead"
    }, [_c('td', [_c('h4', [_vm._v(_vm._s(tasksType.title))])]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.$t('vue2.task_overview.belongs_to')))]), _vm._v(" "), _c('td', {
      staticClass: "is-number"
    }, [_vm._v(_vm._s(_vm.$t('vue2.assign_users_hours.assigned')))])]), _vm._v(" "), _vm._l((tasksType.tasks), function(task) {
      return _c('tr', {
        key: task.id
      }, [_c('td', [_vm._v(_vm._s(task.name))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(task.calendar))]), _vm._v(" "), _c('td', {
        staticClass: "is-number"
      }, [(!_vm.getIsHideHours(task)) ? [_vm._v(_vm._s(task.hours))] : _vm._e()], 2)])
    }), _vm._v(" "), (!_vm.getIsHideTotalHours(tasksType)) ? _c('tr', {
      staticClass: "to-user_tasks__footer"
    }, [_c('td', [_vm._v("I alt")]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', {
      staticClass: "is-number"
    }, [_vm._v(_vm._s(tasksType.totalHours))])]) : _vm._e()], 2)
  }), 0)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-ad750fde!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/User/TaskOverview/TaskOverviewUserTasks.vue
// module id = 1742
// module chunks = 1